import ACL from "../../acl";

/**
 * Is currently logged in use a system admin
 * @return {boolean}
 */
export const isSystemAdmin = () => ACL.isSuper(ACL);